// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postCompareElectricityFees = endpointHelias+'/Helias/V0/Advisory/postCompareElectricityFees'
const postEmail = endpointHelias+'/Helias/V0/Messaging/postEmail'

var generalCommonJS = require("../../../js/generalCommon.js")
var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var advisoryCommonJS = require("../../../js/advisoryCommon.js")
var stripeCommonJS = require("../../../js/stripeCommon.js")


// Advisory - Fees Analyzer
const FeesAnalyzer = (params) => {
  
  useEffect(() => {    

    inicializar()

    if(params.subOption === "Auto"){
      verificarTarifa("Automatica")
    }
    else if(params.subOption === "Public"){         
      mostrarFormularioTarifasPublico()
    }
    
    console.log("Abro analizador de tarifas.")    
  });

  function inicializar(){

    document.getElementById("contenedorInicial").className = document.getElementById("contenedorInicial").className.replaceAll(" hidden", "")
    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("tablaResultadosAnalisis").className = document.getElementById("tablaResultadosAnalisis").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("botonVolverAnalizadorTarifas").className = document.getElementById("botonVolverAnalizadorTarifas").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("analisis12Facturas").className = document.getElementById("analisis12Facturas").className.replaceAll(" hidden", "") + " hidden"    

    //document.getElementById("divTituloResultados").style = "padding-top: 0px"

    document.getElementById("potenciaAnalisisEnergiaP1").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP2").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP3").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP4").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP5").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP6").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP1").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP2").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP3").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP4").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP5").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP6").className = ""      
    document.getElementById("costeServicioMonedero").className = ""      
    document.getElementById("excedenteAnalisis").className = ""      
    document.getElementById("descuentoAnalisis").className = ""      
    //document.getElementById("bonificacionAnalisis").className = ""      

    document.getElementById("potenciaAnalisisEnergiaP1").value = ""
    document.getElementById("potenciaAnalisisEnergiaP2").value = ""
    document.getElementById("potenciaAnalisisEnergiaP3").value = ""
    document.getElementById("potenciaAnalisisEnergiaP4").value = ""
    document.getElementById("potenciaAnalisisEnergiaP5").value = ""
    document.getElementById("potenciaAnalisisEnergiaP6").value = ""
    document.getElementById("tarifaAnalisisEnergiaP1").value = ""
    document.getElementById("tarifaAnalisisEnergiaP2").value = ""
    document.getElementById("tarifaAnalisisEnergiaP3").value = ""
    document.getElementById("tarifaAnalisisEnergiaP4").value = ""
    document.getElementById("tarifaAnalisisEnergiaP5").value = ""
    document.getElementById("tarifaAnalisisEnergiaP6").value = ""    
    document.getElementById("costeServicioMonedero").value = ""
    document.getElementById("excedenteAnalisis").value = ""
    document.getElementById("descuentoAnalisis").value = ""
    //document.getElementById("bonificacionAnalisis").value = ""

  }

  function mostrarFormularioTarifas(){
    
    var lastDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
    var numeroPotenciasConfiguradas = lastDashboardData.InstallationData.GeneralInfo.PowerConfiguration.split("#").length

    document.getElementById("acordeonFormularioAnalisisTarifas").className = document.getElementById("acordeonFormularioAnalisisTarifas").className.replaceAll(" hidden", "")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("open","")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("disabled","")
    document.getElementById("botonVolverAnalizadorTarifas").className = document.getElementById("botonVolverAnalizadorTarifas").className.replaceAll(" hidden", "")
    
    if(numeroPotenciasConfiguradas === 6){ //3.0

      document.getElementById("fieldsetCamposTarifasPotencia").className = document.getElementById("fieldsetCamposTarifasPotencia").className.replaceAll(" col-lg-2", "") + " col-lg-2"
      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" col-lg-2", "") + " col-lg-2"

      document.getElementById("trPotenciaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

      document.getElementById("trTarifaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

      document.getElementById("fieldsetDescuento").className = document.getElementById("fieldsetDescuento").className.replaceAll(" hidden", "")
      //document.getElementById("fieldsetBonificacion").className = document.getElementById("fieldsetBonificacion").className.replaceAll(" hidden", "")

    }
    else{ // 2.0

      document.getElementById("fieldsetCamposTarifasPotencia").className = document.getElementById("fieldsetCamposTarifasPotencia").className.replaceAll(" col-lg-2", "") + " col-lg-2"
      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" col-lg-2", "")

      document.getElementById("trPotenciaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("trTarifaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTarifaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTarifaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("fieldsetDescuento").className = document.getElementById("fieldsetDescuento").className.replaceAll(" hidden", "")
      //document.getElementById("fieldsetBonificacion").className = document.getElementById("fieldsetBonificacion").className.replaceAll(" hidden", "")

    }

    if(Object.keys(lastDashboardData.FVData).length > 0){
      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetExcedente").className = document.getElementById("fieldsetExcedente").className.replaceAll(" hidden", "")      
    }
    else{
      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetExcedente").className = document.getElementById("fieldsetExcedente").className.replaceAll(" hidden", "") + " hidden"
    }

    document.getElementById("descuentoAnalisis").placeholder = "Opcional"
    //document.getElementById("bonificacionAnalisis").placeholder = "Opcional"
    

    document.getElementById("contenedorInicial").className = document.getElementById("contenedorInicial").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "")
    document.getElementById("tablaResultadosAnalisis").className = document.getElementById("tablaResultadosAnalisis").className.replaceAll(" hidden", "") + " hidden"

  }

  function mostrarFormularioTarifasPublico(){
    
    var numeroPotenciasConfiguradas = "6"
    var tienePaneles = true

    document.getElementById("acordeonFormularioAnalisisTarifas").className = document.getElementById("acordeonFormularioAnalisisTarifas").className.replaceAll(" hidden", "")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("open","")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("disabled","")
    document.getElementById("botonVolverAnalizadorTarifas").className = document.getElementById("botonVolverAnalizadorTarifas").className.replaceAll(" hidden", "")
    
    if(numeroPotenciasConfiguradas === 6){ //3.0

      document.getElementById("fieldsetCamposTarifasPotencia").className = document.getElementById("fieldsetCamposTarifasPotencia").className.replaceAll(" col-lg-2", "") + " col-lg-2"
      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" col-lg-2", "") + " col-lg-2"

      document.getElementById("trPotenciaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

      document.getElementById("trTarifaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

      document.getElementById("fieldsetDescuento").className = document.getElementById("fieldsetDescuento").className.replaceAll(" hidden", "")
      //document.getElementById("fieldsetBonificacion").className = document.getElementById("fieldsetBonificacion").className.replaceAll(" hidden", "")

    }
    else{ // 2.0

      document.getElementById("fieldsetCamposTarifasPotencia").className = document.getElementById("fieldsetCamposTarifasPotencia").className.replaceAll(" col-lg-2", "") + " col-lg-2"
      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" col-lg-2", "")

      document.getElementById("trPotenciaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("trTarifaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTarifaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trTarifaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("fieldsetDescuento").className = document.getElementById("fieldsetDescuento").className.replaceAll(" hidden", "")
      //document.getElementById("fieldsetBonificacion").className = document.getElementById("fieldsetBonificacion").className.replaceAll(" hidden", "")

    }

    if(tienePaneles){
      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetExcedente").className = document.getElementById("fieldsetExcedente").className.replaceAll(" hidden", "")      
    }
    else{
      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetExcedente").className = document.getElementById("fieldsetExcedente").className.replaceAll(" hidden", "") + " hidden"
    }

    document.getElementById("descuentoAnalisis").placeholder = "Opcional"
    //document.getElementById("bonificacionAnalisis").placeholder = "Opcional"
    

    document.getElementById("contenedorInicial").className = document.getElementById("contenedorInicial").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "")
    document.getElementById("tablaResultadosAnalisis").className = document.getElementById("tablaResultadosAnalisis").className.replaceAll(" hidden", "") + " hidden"

  }

  function obtenerCampoVerificado(idCampo){

    var campoVerificado = document.getElementById(idCampo).value

    if(campoVerificado !== ""){
      campoVerificado = campoVerificado.replaceAll(",",".").replaceAll(" ","")
    }
    else{
      campoVerificado = 0
    }
    
    return parseFloat(campoVerificado)

  }

  function validarFormulario(){

    document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0

    var lastDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
    var numeroPotenciasConfiguradas = lastDashboardData.InstallationData.GeneralInfo.PowerConfiguration.split("#").length

    var numeroErroresValidacion = 0

    document.getElementById("potenciaAnalisisEnergiaP1").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP2").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP3").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP4").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP5").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP6").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP1").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP2").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP3").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP4").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP5").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP6").className = ""          
    document.getElementById("costeServicioMonedero").className = ""      
    document.getElementById("excedenteAnalisis").className = ""      
    document.getElementById("descuentoAnalisis").className = ""      
    //document.getElementById("bonificacionAnalisis").className = ""      
    
    if(numeroPotenciasConfiguradas === 6){ //3.0
    
      for(var x=0;x<6;x++){
        if(document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      for(x=0;x<1;x++){
        if(document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      if(Object.keys(lastDashboardData.FVData).length > 0){
        if(document.getElementById("excedenteAnalisis").value === ""){
          numeroErroresValidacion++
          document.getElementById("excedenteAnalisis").className = "error"
        }
        if(document.getElementById("costeServicioMonedero").value === ""){
          numeroErroresValidacion++
          document.getElementById("costeServicioMonedero").className = "error"
        }
      }

    }
    else{ //2.0

      for(x=0;x<2;x++){
        if(document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      for(x=0;x<1;x++){
        if(document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      if(Object.keys(lastDashboardData.FVData).length > 0){
        if(document.getElementById("excedenteAnalisis").value === ""){
          numeroErroresValidacion++
          document.getElementById("excedenteAnalisis").className = "error"
        }
        if(document.getElementById("costeServicioMonedero").value === ""){
          numeroErroresValidacion++
          document.getElementById("costeServicioMonedero").className = "error"
        }
      }

    }

    if(numeroErroresValidacion > 0){      
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos obligatorios.","negative")
      return false
    }
    else{      
      return true
    }

  }

  function verificarTarifa(tipoSimulacion){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    //Payload petición

    var jsonPeticion = ""
    var ejecutarPeticion = false

    document.getElementById("acordeonCalculosResultados").removeAttribute("open")        

    if(tipoSimulacion === "Manual"){
        
      if(validarFormulario()){

        document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("open")        
        document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("disabled")        
              
        jsonPeticion = {
          "accountID": localStorage.getItem("accountID"),
          "installationID": localStorage.getItem("installationId"),
          "customFee": {        
            "Power": [
              obtenerCampoVerificado("potenciaAnalisisEnergiaP1"),
              obtenerCampoVerificado("potenciaAnalisisEnergiaP2"),
              obtenerCampoVerificado("potenciaAnalisisEnergiaP3"),
              obtenerCampoVerificado("potenciaAnalisisEnergiaP4"),
              obtenerCampoVerificado("potenciaAnalisisEnergiaP5"),
              obtenerCampoVerificado("potenciaAnalisisEnergiaP6")],
            "Energy": [
              obtenerCampoVerificado("tarifaAnalisisEnergiaP1"),
              obtenerCampoVerificado("tarifaAnalisisEnergiaP2"),
              obtenerCampoVerificado("tarifaAnalisisEnergiaP3"),
              obtenerCampoVerificado("tarifaAnalisisEnergiaP4"),
              obtenerCampoVerificado("tarifaAnalisisEnergiaP5"),
              obtenerCampoVerificado("tarifaAnalisisEnergiaP6")],
            "Surplus": obtenerCampoVerificado("excedenteAnalisis"),
            "SolarWalletCost": obtenerCampoVerificado("costeServicioMonedero"),            
            "Discount": obtenerCampoVerificado("descuentoAnalisis"),
            "Bonus": 0,            
            "BonusType": ""
            
          }
        }
        
        ejecutarPeticion = true

      }
      else{
        ejecutarPeticion = false
      }

    }
    else{ //Automática
      
      document.getElementById("acordeonFormularioAnalisisTarifas").className = document.getElementById("acordeonFormularioAnalisisTarifas").className.replaceAll(" hidden", "") + " hidden"

      jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId")
      }   

      ejecutarPeticion = true

    }

    
    if(ejecutarPeticion){

      document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "")

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - Analizador '+tipoSimulacion, "", "")

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postCompareElectricityFees, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)

            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }          
            else{          
              //Si recibo datos ya configurados lo cargo  

              document.getElementById("botonVolverAnalizadorTarifas").className = document.getElementById("botonVolverAnalizadorTarifas").className.replaceAll(" hidden", "")        

              var lastDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
              var numeroPotenciasConfiguradas = lastDashboardData.InstallationData.GeneralInfo.PowerConfiguration.split("#").length

              if(numeroPotenciasConfiguradas === 6){ //3.0

                document.getElementById("trPotenciaP1").className = document.getElementById("trPotenciaP1").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP2").className = document.getElementById("trPotenciaP2").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP3").className = document.getElementById("trPotenciaP3").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP4").className = document.getElementById("trPotenciaP4").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP5").className = document.getElementById("trPotenciaP5").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP6").className = document.getElementById("trPotenciaP6").className.replaceAll(" hidden", "")
          
                document.getElementById("trEnergiaP1").className = document.getElementById("trEnergiaP1").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP2").className = document.getElementById("trEnergiaP2").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP3").className = document.getElementById("trEnergiaP3").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP4").className = document.getElementById("trEnergiaP4").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP5").className = document.getElementById("trEnergiaP5").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP6").className = document.getElementById("trEnergiaP6").className.replaceAll(" hidden", "")

              }
              else{ //2.0
          
                document.getElementById("trPotenciaP1").className = document.getElementById("trPotenciaP1").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP2").className = document.getElementById("trPotenciaP2").className.replaceAll(" hidden", "")
                document.getElementById("trPotenciaP3").className = document.getElementById("trPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("trPotenciaP4").className = document.getElementById("trPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("trPotenciaP5").className = document.getElementById("trPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("trPotenciaP6").className = document.getElementById("trPotenciaP6").className.replaceAll(" hidden", "") + " hidden"
          
                document.getElementById("trEnergiaP1").className = document.getElementById("trEnergiaP1").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP2").className = document.getElementById("trEnergiaP2").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP3").className = document.getElementById("trEnergiaP3").className.replaceAll(" hidden", "")
                document.getElementById("trEnergiaP4").className = document.getElementById("trEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("trEnergiaP5").className = document.getElementById("trEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("trEnergiaP6").className = document.getElementById("trEnergiaP6").className.replaceAll(" hidden", "") + " hidden"
              }


              document.getElementById("contenedorInicial").className = document.getElementById("contenedorInicial").className.replaceAll(" hidden", "") + " hidden"
              document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "")    
              document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("open")
              document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("disabled")        
              document.getElementById("tablaResultadosAnalisis").className = document.getElementById("tablaResultadosAnalisis").className.replaceAll(" hidden", "")
              document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "")
              document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "")
              document.getElementById("divCompartenosTuTarifa").className = document.getElementById("divCompartenosTuTarifa").className.replaceAll(" hidden", "") + " hidden" 
              document.getElementById("mensajeRecordatorioReconfiguracion").className = document.getElementById("mensajeRecordatorioReconfiguracion").className.replaceAll(" hidden", "") + " hidden" 
              
              if(jsonRespuesta.body.OfferInfo.InfoUrl === ""){                
                document.getElementById("aLinkOferta").className = document.getElementById("aLinkOferta").className.replaceAll(" hidden","") + " hidden"
              }
              else{
                document.getElementById("aLinkOferta").className = document.getElementById("aLinkOferta").className.replaceAll(" hidden","")
                document.getElementById("aLinkOferta").innerHTML = jsonRespuesta.body.OfferInfo.FeeName + '<span class="material-icon">arrow_forward</span>'
                document.getElementById("aLinkOferta").href = jsonRespuesta.body.OfferInfo.InfoUrl                              
              }
              
              //RESUMEN FINAL              
              document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "")
              document.getElementById("divCompartenosTuTarifa").className = document.getElementById("divCompartenosTuTarifa").className.replaceAll(" hidden", "") + " hidden"              

              document.getElementById("textoIntroCalculos").innerHTML = "He considerado tus datos de los <strong>últimos " + jsonRespuesta.body.Totals.DaysConsidered +" días</strong>"

              document.getElementById("textoResumenResultado").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo(jsonRespuesta.body.Totals.DecissionCode)            
              document.getElementById("textoResumenTipoResultado").innerHTML = initialConfigCommonJS.obtenerLiteralAtributo(jsonRespuesta.body.Totals.SavingsRateCode)    
              document.getElementById("spanAlAño").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.Totals.YearlySavings.replaceAll("-","")) + " €"
              document.getElementById("spanAlMes").innerHTML = new Intl.NumberFormat('en-DE').format(jsonRespuesta.body.Totals.MonthlySavings.replaceAll("-","")) + " €"
              
              //BALANCE FINAL Y MEDIA MENSUAL
              document.getElementById("valorBalanceFinalActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.BalanceTotal).toFixed(2)) + " €"
              document.getElementById("valorBalanceFinalOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.BalanceTotal).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorBalanceFinal", jsonRespuesta.body.Now.BalanceTotal, jsonRespuesta.body.Offer.BalanceTotal)

              if(jsonRespuesta.body.Now.BalanceTotal > 0){
                document.getElementById("valorBalanceFinalActual").innerHTML = "+"+document.getElementById("valorBalanceFinalActual").innerHTML                
              }
              
              if(jsonRespuesta.body.Offer.BalanceTotal > 0){
                document.getElementById("valorBalanceFinalOferta").innerHTML = "+"+document.getElementById("valorBalanceFinalOferta").innerHTML
              }

              if( (jsonRespuesta.body.Now.BalanceTotal > 0) || (jsonRespuesta.body.Offer.BalanceTotal > 0) ){
                document.getElementById("literalTotales").innerHTML = "Factura 0€ y ganarías"   
              }
              else{
                document.getElementById("literalTotales").innerHTML = "Total facturas"                
              }

              document.getElementById("acordeonCalculosResultados").className = document.getElementById("acordeonCalculosResultados").className.replaceAll(" hidden", "")

              if( 
                (jsonRespuesta.body.Totals.DecissionCode === "FA_WALLET_POSITIVE") || 
                (jsonRespuesta.body.Totals.DecissionCode === "FA_NO_CHANGE") || 
                (jsonRespuesta.body.Totals.DecissionCode === "FA_WASTE") ||
                (jsonRespuesta.body.Totals.SavingsRateCode === "FA_MORE_WASTE") 
              ){ //Oculto datos de la oferta
                document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "") + " hidden" 
                document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "") + " hidden" 
                document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "") + " hidden"
                document.getElementById("mensajeRecordatorioReconfiguracion").className = document.getElementById("mensajeRecordatorioReconfiguracion").className.replaceAll(" hidden", "") + " hidden"
                
                document.getElementById("acordeonCalculosResultados").className = document.getElementById("acordeonCalculosResultados").className.replaceAll(" hidden", "") + " hidden" 


                if(jsonRespuesta.body.Totals.DecissionCode === "FA_NO_CHANGE"){                  
                  document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "")
                }

                if((jsonRespuesta.body.Totals.DecissionCode === "FA_WALLET_POSITIVE") && ((jsonRespuesta.body.Totals.SavingsRateCode !== "FA_MORE_WASTE"))){                                    
                  document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "")
                  document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "")
                  document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "")
                  document.getElementById("acordeonCalculosResultados").className = document.getElementById("acordeonCalculosResultados").className.replaceAll(" hidden", "")
                }

              }
              else{ //Muestro datos de la oferta
                document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "")
                document.getElementById("divImportesResultados").className = document.getElementById("divImportesResultados").className.replaceAll(" hidden", "")
                document.getElementById("divBloqueOferta").className = document.getElementById("divBloqueOferta").className.replaceAll(" hidden", "")
                document.getElementById("mensajeRecordatorioReconfiguracion").className = document.getElementById("mensajeRecordatorioReconfiguracion").className.replaceAll(" hidden", "")                

                if( (!jsonRespuesta.body.Totals.InstallationType.includes("FV")) && (jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("solar")) ){ 
                  document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "")                
                }
                else{
                  document.getElementById("mensajeComentarioContrataSolarSinPaneles").className = document.getElementById("mensajeComentarioContrataSolarSinPaneles").className.replaceAll(" hidden", "") + " hidden"            
                }
                
              }

              if(
                (jsonRespuesta.body.Totals.SavingsRateCode === "FA_MORE_WASTE") ||
                (jsonRespuesta.body.Totals.DecissionCode === "FA_WASTE")
              ){
                document.getElementById("divCompartenosTuTarifa").className = document.getElementById("divCompartenosTuTarifa").className.replaceAll(" hidden", "")      

                if( (jsonRespuesta.body.Totals.SavingsRateCode === "FA_MORE_WASTE") || (jsonRespuesta.body.Totals.DecissionCode === "FA_NO_CHANGE") ){                
                  document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "") + " hidden"      
                }
                else{
                  document.getElementById("textoResumenResultado").className = document.getElementById("textoResumenResultado").className.replaceAll(" hidden", "")
                }

              }
              else{
                document.getElementById("divCompartenosTuTarifa").className = document.getElementById("divCompartenosTuTarifa").className.replaceAll(" hidden", "") + " hidden"      
              }


              //POTENCIA              
              document.getElementById("potenciaContratadaP1").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P1).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P1).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P1).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP1", jsonRespuesta.body.Now.ContractedPowerCost.P1, jsonRespuesta.body.Offer.ContractedPowerCost.P1)
              
              document.getElementById("tarifaPotenciaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P1).toFixed(3))
              document.getElementById("tarifaPotenciaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P1).toFixed(3))
              
              document.getElementById("potenciaContratadaP2").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P2).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P2).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P2).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP2", jsonRespuesta.body.Now.ContractedPowerCost.P2, jsonRespuesta.body.Offer.ContractedPowerCost.P2)
              
              document.getElementById("tarifaPotenciaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P2).toFixed(3))
              document.getElementById("tarifaPotenciaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P2).toFixed(3))

              document.getElementById("potenciaContratadaP3").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P3).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P3).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P3).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP3", jsonRespuesta.body.Now.ContractedPowerCost.P3, jsonRespuesta.body.Offer.ContractedPowerCost.P3)

              document.getElementById("tarifaPotenciaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P3).toFixed(3))
              document.getElementById("tarifaPotenciaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P3).toFixed(3))

              document.getElementById("potenciaContratadaP4").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P4).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P4).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P4).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP4", jsonRespuesta.body.Now.ContractedPowerCost.P4, jsonRespuesta.body.Offer.ContractedPowerCost.P4)

              document.getElementById("tarifaPotenciaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P4).toFixed(3))
              document.getElementById("tarifaPotenciaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P4).toFixed(3))

              document.getElementById("potenciaContratadaP5").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P5).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P5).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P5).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP5", jsonRespuesta.body.Now.ContractedPowerCost.P5, jsonRespuesta.body.Offer.ContractedPowerCost.P5)

              document.getElementById("tarifaPotenciaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P5).toFixed(3))
              document.getElementById("tarifaPotenciaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P5).toFixed(3))

              document.getElementById("potenciaContratadaP6").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.PowerContracted.P6).toFixed(2)) + " kW"              
              document.getElementById("valorPotenciaContratadaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerCost.P6).toFixed(2)) + " €"
              document.getElementById("valorPotenciaContratadaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerCost.P6).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorPotenciaContratadaP6", jsonRespuesta.body.Now.ContractedPowerCost.P6, jsonRespuesta.body.Offer.ContractedPowerCost.P6)

              document.getElementById("tarifaPotenciaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ContractedPowerFee.P6).toFixed(3))
              document.getElementById("tarifaPotenciaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ContractedPowerFee.P6).toFixed(3))
              
              //ENERGÍA
              if(jsonRespuesta.body.Totals.BoughtEnergy.P1 > 1000){
                document.getElementById("consumoEnergiaP1").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P1/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP1").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P1).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P1).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P1).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP1", jsonRespuesta.body.Now.EnergyCost.P1, jsonRespuesta.body.Offer.EnergyCost.P1)

              document.getElementById("tarifaEnergiaP1Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P1).toFixed(3))
              document.getElementById("tarifaEnergiaP1Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P1).toFixed(3))
              

              if(jsonRespuesta.body.Totals.BoughtEnergy.P2 > 1000){
                document.getElementById("consumoEnergiaP2").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P2/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP2").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P2).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P2).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P2).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP2", jsonRespuesta.body.Now.EnergyCost.P2, jsonRespuesta.body.Offer.EnergyCost.P2)

              document.getElementById("tarifaEnergiaP2Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P2).toFixed(3))
              document.getElementById("tarifaEnergiaP2Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P2).toFixed(3))

              if(jsonRespuesta.body.Totals.BoughtEnergy.P3 > 1000){
                document.getElementById("consumoEnergiaP3").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P3/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP3").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P3).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P3).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P3).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP3", jsonRespuesta.body.Now.EnergyCost.P3, jsonRespuesta.body.Offer.EnergyCost.P3)

              document.getElementById("tarifaEnergiaP3Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P3).toFixed(3))
              document.getElementById("tarifaEnergiaP3Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P3).toFixed(3))

              if(jsonRespuesta.body.Totals.BoughtEnergy.P4 > 1000){
                document.getElementById("consumoEnergiaP4").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P4/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP4").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P4).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P4).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P4).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP4", jsonRespuesta.body.Now.EnergyCost.P4, jsonRespuesta.body.Offer.EnergyCost.P4)

              document.getElementById("tarifaEnergiaP4Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P4).toFixed(3))
              document.getElementById("tarifaEnergiaP4Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P4).toFixed(3))

              if(jsonRespuesta.body.Totals.BoughtEnergy.P5 > 1000){
                document.getElementById("consumoEnergiaP5").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P5/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP5").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P5).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P5).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P5).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP5", jsonRespuesta.body.Now.EnergyCost.P5, jsonRespuesta.body.Offer.EnergyCost.P5)

              document.getElementById("tarifaEnergiaP5Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P5).toFixed(3))
              document.getElementById("tarifaEnergiaP5Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P5).toFixed(3))

              if(jsonRespuesta.body.Totals.BoughtEnergy.P6 > 1000){
                document.getElementById("consumoEnergiaP6").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P6/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("consumoEnergiaP6").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.BoughtEnergy.P6).toFixed(2)) + " kWh"
              }
              document.getElementById("valorEnergiaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyCost.P6).toFixed(2)) + " €"
              document.getElementById("valorEnergiaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyCost.P6).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEnergiaP6", jsonRespuesta.body.Now.EnergyCost.P6, jsonRespuesta.body.Offer.EnergyCost.P6)

              document.getElementById("tarifaEnergiaP6Actual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyFee.P6).toFixed(3))
              document.getElementById("tarifaEnergiaP6Oferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyFee.P6).toFixed(3))

              //EXCEDENTE
              if(jsonRespuesta.body.Totals.SoldEnergy > 1000){
                document.getElementById("valorExcedente").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.SoldEnergy/1000).toFixed(2)) + " MWh"                
              }
              else{
                document.getElementById("valorExcedente").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Totals.SoldEnergy).toFixed(2)) + " kWh"
              }

              document.getElementById("valorExcedenteActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.SoldEnergy).toFixed(2)) + " €"
              document.getElementById("tarifaExcedenteActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.SurplusFee).toFixed(3))            

              document.getElementById("valorExcedenteOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.SoldEnergy).toFixed(2)) + " €"
              document.getElementById("tarifaExcedenteOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.SurplusFee).toFixed(3))              


              advisoryCommonJS.setearColoresValorBonificacion("valorExcedente", jsonRespuesta.body.Now.EnergyRevenue.SoldEnergy, jsonRespuesta.body.Offer.EnergyRevenue.SoldEnergy)

              if(Object.keys(lastDashboardData.FVData).length > 0){ //Tiene fotovoltaica                
                document.getElementById("trExcedente").className = document.getElementById("trExcedente").className.replaceAll(" hidden","")
              }
              else{
                document.getElementById("trExcedente").className = document.getElementById("trExcedente").className.replaceAll(" hidden","") + " hidden"
              }

              //DESCUENTO
              document.getElementById("valorDescuentoActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EnergyRevenue.Discounts).toFixed(2)) + " €"
              document.getElementById("valorDescuentoOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.Discounts).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorBonificacion("valorDescuento", jsonRespuesta.body.Now.EnergyRevenue.Discounts, jsonRespuesta.body.Offer.EnergyRevenue.Discounts)
            
              var labelTextoBonificacion = ""

              if((parseFloat(jsonRespuesta.body.Offer.EnergyRevenue.Bonus) > 0)){     

                if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "referido"){

                  if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("octopus")){
                    labelTextoBonificacion = "Y si conoces a alguien con Octopus y usas su enlace de referido <strong>te bonificarán con "+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+" € adicionales</strong> a lo indicado arriba. Si no conoces a nadie <strong><a className='link inline-link' href='mailto:info@fevergy.com'>escríbenos</a></strong> y te conseguimos uno."
                  }
                  else{
                    advisoryCommonJS.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)                    
                  }

                }
                else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "directo"){

                  if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("octopus")){
                    labelTextoBonificacion = "Y encima sólo por irte con ellos <strong>te regalan directamente "+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+" € </strong> adicionales a lo indicado arriba. "
                  }
                  else{
                    advisoryCommonJS.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)                    
                  }
  
                }
                else if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType.toLowerCase() === "gasolina"){                  
                  labelTextoBonificacion = "Y además si contratas esta tarifa <strong>te bonificarán con "+jsonRespuesta.body.Offer.EnergyRevenue.Bonus+" € adicionales en gasolina</strong>"
                }
                else{
                  advisoryCommonJS.enviarEmailBonificacionNoControlada("Oferta con bonificación no controlada: "+ jsonRespuesta.body.OfferInfo.FeeName + " ,valor: " + jsonRespuesta.body.Offer.EnergyRevenue.Bonus + " , tipo:"+jsonRespuesta.body.Offer.EnergyRevenue.BonusType)
                }
                
                if( (jsonRespuesta.body.Totals.DecissionCode === "FA_CHANGE") || (jsonRespuesta.body.Totals.DecissionCode === "FA_UP2U") ){                  
                  document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
                  document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
                }
                else{                  
                  document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") + " hidden"
                }
                
              }
              else{

                if(jsonRespuesta.body.Offer.EnergyRevenue.BonusType === "MERCADO_REGULADO"){ 
                  labelTextoBonificacion = "Al ser una tarifa de mercado regulado <strong>da igual con quien la contrates, todas deberían darte las mismas condiciones</strong>. Pulsa en el botón para ver las comercializadoras existentes."
                  document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
                  document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
                }
                else{
                  document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") + " hidden"
                }
                
              }

              if(jsonRespuesta.body.OfferInfo.FeeName.toLowerCase().includes("som energia")){
                document.getElementById("labelTextoBonificacion").className = document.getElementById("labelTextoBonificacion").className.replaceAll(" hidden","") 
                labelTextoBonificacion = 'Som Energia es una cooperativa y te pedirán darte de alta como socio por 100€, pero tranquil@ que no hay permanencia y cuando decidas irte te los devolverán.'
                document.getElementById("labelTextoBonificacion").innerHTML = labelTextoBonificacion
              }


              //OTROS GASTOS

              document.getElementById("valorEquiposMedicionActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.EquipmentHiring).toFixed(2)) + " €"
              document.getElementById("valorEquiposMedicionOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.EquipmentHiring).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorEquiposMedicion", jsonRespuesta.body.Now.EquipmentHiring, jsonRespuesta.body.Offer.EquipmentHiring)

              document.getElementById("valorMonederoSolarActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.SolarWallet).toFixed(2)) + " €"
              document.getElementById("valorMonederoSolarOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.SolarWallet).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorMonederoSolar", jsonRespuesta.body.Now.SolarWallet, jsonRespuesta.body.Offer.SolarWallet)

              if(Object.keys(lastDashboardData.FVData).length > 0){ //Tiene fotovoltaica            
                document.getElementById("trGastosFijosMonederoSolar").className = document.getElementById("trGastosFijosMonederoSolar").className.replaceAll(" hidden","")
              }
              else{
                document.getElementById("trGastosFijosMonederoSolar").className = document.getElementById("trGastosFijosMonederoSolar").className.replaceAll(" hidden","") + " hidden"
              }

              document.getElementById("valorComisionFijaCompañiaActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.MonthlyCompanyFee).toFixed(2)) + " €"
              document.getElementById("valorComisionFijaCompañiaOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.MonthlyCompanyFee).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorComisionFijaCompañia", jsonRespuesta.body.Now.MonthlyCompanyFee, jsonRespuesta.body.Offer.MonthlyCompanyFee)

              //IMPUESTOS

              document.getElementById("valorBonoSocialActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.SocialBonus).toFixed(2)) + " €"
              document.getElementById("valorBonoSocialOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.SocialBonus).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorBonoSocial", jsonRespuesta.body.Now.SocialBonus, jsonRespuesta.body.Offer.SocialBonus)

              document.getElementById("valorImpuestoElectricidadActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.ElectricityTax).toFixed(2)) + " €"
              document.getElementById("valorImpuestoElectricidadOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.ElectricityTax).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("valorImpuestoElectricidad", jsonRespuesta.body.Now.ElectricityTax, jsonRespuesta.body.Offer.ElectricityTax)

              document.getElementById("importeIVAActual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Now.IVA).toFixed(2)) + " €"
              document.getElementById("importeIVAOferta").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(jsonRespuesta.body.Offer.IVA).toFixed(2)) + " €"
              advisoryCommonJS.setearColoresValorGasto("importeIVA", jsonRespuesta.body.Now.IVA, jsonRespuesta.body.Offer.IVA)

              console.log("Análisis de tarifas realizado correctamente.")

            }            

          }

          if (this.readyState === 4 && this.status !== 200) { 
            initialConfigCommonJS.mostrarMensajeInformativo("Hubo un problema al realizar el análisis de tarifas, vuelve a intentarlo pasados unos minutos.","negative")         
          }

          document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "") + " hidden"
          
        }
        xhttp.send(data); 
    }

  }

  function enviarEmailTarifaMejor(){

    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "")

    var cuerpoCompletoMensaje = localStorage.getItem("installationId")+"<BR><BR>Mi tarifa es mejor, aquí tienes la información: "+document.getElementById("nombreCompañiaMejorTarifa").value

    //Petición de datos para el paso actual
    var jsonPeticion = {            
      "mensaje": generalCommonJS.obtenerEmailUsuario()+"###"+cuerpoCompletoMensaje,      
      "origen": "WEB"
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postEmail, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");      
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("Se ha producido un error al enviar el mensaje, vuelve a intentarlo en unos minutos.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  

            if(typeof jsonRespuesta.body !== 'undefined'){             
              initialConfigCommonJS.mostrarMensajeInformativo("Ya nos llegó tu mensaje. ¡Gracias!","positive")                            
            }  

            generalCommonJS.registrarEventoAnalitica(ReactGA, 'ADVISORY', 'ADVISORY - Mejor tarifa', generalCommonJS.obtenerEmailUsuario()+"###"+cuerpoCompletoMensaje, "")

            //Si no hay datos configurados entonces no hago nada  
            console.log("Feedback mejor tarifa enviada correctamente.")
          }

          document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);    

  }

  function mostrar12Facturas(){
    
    document.getElementById("contenedorInicial").className = document.getElementById("contenedorInicial").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("botonVolverAnalizadorTarifas").className = document.getElementById("botonVolverAnalizadorTarifas").className.replaceAll(" hidden", "")
    document.getElementById("analisis12Facturas").className = document.getElementById("analisis12Facturas").className.replaceAll(" hidden", "")

    var datosStripe = {}
                      
    if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
      datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
    } 

    if(datosStripe.status === "trialing"){
      document.getElementById("mensaje12FacturasVersionPrueba").className = document.getElementById("mensaje12FacturasVersionPrueba").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("mensaje12FacturasVersionPrueba").className = document.getElementById("mensaje12FacturasVersionPrueba").className.replaceAll(" hidden", "") + " hidden"
    }

  }

  return (      
      <>
          
          <button id="botonVolverAnalizadorTarifas" className="link back hidden" onClick={() => inicializar()}><span className="material-icon">arrow_back</span>Volver</button>

          <div id="contenedorInicial" className="vertical gap-06">

              <div id="stepIntroBubble">
                <p id="textoIntro" className="">La mejor manera de ahorrar es tener siempre la tarifa que mejor se adapte a tus hábitos de consumo y a tu tipo de instalación.</p>
              </div>

                <section className="widget bubble pointer" onClick={() => verificarTarifa("Automatica")}>
                  <div className="vertical gap-04">
                    <div className="gap-03 horizontal vertical-center">
                      <figure className="avatar size-l pink">
                        <span className="material-icon">query_stats</span>
                      </figure>
                      <h1 className="headline-03">Búscame la mejor oferta</h1>
                    </div>
                    <p>Evaluaré los datos de tu instalación para asegurarte que tienes la mejor tarifa del mercado.</p>
                  </div>
                  <button className="link">Sí, vamos a ello</button>
                </section>

                <section className="widget bubble pointer" onClick={() => mostrarFormularioTarifas()}>
                  <div className="vertical gap-04">
                    <div className="gap-03 horizontal vertical-center">
                      <figure className="avatar size-l pink">
                        <span className="material-icon">local_offer</span>
                      </figure>
                      <h1 className="headline-03">Me han hecho una oferta</h1>
                    </div>
                    <p>Todas las ofertas parecen atractivas, pero no siempre lo son. Yo te diré si realmente te conviene o es puro cuento.</p>
                  </div>
                  <button className="link">Veamos si me conviene</button>
                </section>                

                <section className="widget bubble pointer" onClick={() => mostrar12Facturas()}>
                  <div className="vertical gap-04">
                    <div className="gap-03 horizontal vertical-center">
                      <figure className="avatar size-l pink">
                        <span className="material-icon">receipt_long</span>
                      </figure>
                      <h1 className="headline-03">Análisis 12 facturas</h1>
                    </div>
                    <p>Mándanos las últimas 12 facturas de una instalación y te buscamos el ahorro máximo.</p>
                  </div>
                  <button className="link">Vale, quiero enviarlas</button>
                </section>

          </div>

          <div id="formularioTarifas" className="vertical hidden">

            <div className="accordion-wrapper" >

              <details id="acordeonFormularioAnalisisTarifas" className="accordion" open disabled>
                
                <summary className="title">
                  <figure className="avatar size-l green">
                    <span className="material-icon">euro</span>
                  </figure>
                  <h1 id="tituloComparativa" className="size-l">¿Qué te ofrecen?</h1>
                </summary>

                <fieldset className="accordion-content vertical gap-08">

                  <fieldset>
                    <span className="size-l">Tarifas potencia</span>
                    
                    <fieldset id="fieldsetCamposTarifasPotencia" className="columns col-lg-2">
                    
                      <fieldset id="trPotenciaAnalisisEnergiaP1">
                        <label htmlFor="potenciaAnalisisEnergiaP1">P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                      <fieldset id="trPotenciaAnalisisEnergiaP2">
                        <label htmlFor="potenciaAnalisisEnergiaP2">P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                      <fieldset id="trPotenciaAnalisisEnergiaP3">
                        <label htmlFor="potenciaAnalisisEnergiaP3">P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trPotenciaAnalisisEnergiaP4">
                        <label htmlFor="potenciaAnalisisEnergiaP4">P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trPotenciaAnalisisEnergiaP5">
                        <label htmlFor="potenciaAnalisisEnergiaP5">P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trPotenciaAnalisisEnergiaP6">
                        <label htmlFor="potenciaAnalisisEnergiaP6">P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kW/día">
                          <input id="potenciaAnalisisEnergiaP6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>
                  </fieldset>

                  <fieldset>
                    <span className="size-l">Tarifas energía</span>

                    <fieldset id="fieldsetCamposTarifasEnergia" className="columns col-lg-2">

                      <fieldset id="trTarifaAnalisisEnergiaP1">
                        <label htmlFor="trTarifaAnalisisEnergiaP1">P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaAnalisisEnergiaP2">
                        <label htmlFor="trTarifaAnalisisEnergiaP2">P2 (Opcional)</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaAnalisisEnergiaP3">
                        <label htmlFor="trTarifaAnalisisEnergiaP3">P3 (Opcional)</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaAnalisisEnergiaP4">
                        <label htmlFor="trTarifaAnalisisEnergiaP4">P4 (Opcional)</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaAnalisisEnergiaP5">
                        <label htmlFor="trTarifaAnalisisEnergiaP5">P5 (Opcional)</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaAnalisisEnergiaP6">
                        <label htmlFor="trTarifaAnalisisEnergiaP6">P6 (Opcional)</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="tarifaAnalisisEnergiaP6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>
                  </fieldset>

                  <fieldset className="vertical gap-04">

                    <span className="size-l">Otros</span>

                    <fieldset id="fieldsetExcedente" className="tooltip-parent">

                       <fieldset>                      
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Tarifa venta excedente</span>                        
                        </span>
                      
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input type="text" inputMode="decimal" id="excedenteAnalisis" className="" />
                        </fieldset>                      
                      </fieldset>

                    </fieldset>
                  
                    <fieldset id="fieldsetCosteServicioMonedero" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Coste servicio monedero</span>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">¿Cobran por el servicio de monedero?</p>
                                <p className="size-s">En ocasiones las comercializadoras cobran por tener el servicio de monedero solar/ baterías virtuales activado. Aquí debes indicar el coste del servicio por mes sin IVA. Si no cobran pon directamente 0€.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€/Mes">
                          <input type="text" inputMode="decimal" id="costeServicioMonedero" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetDescuento" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Descuento</span>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">¿Hacen algún descuento?</p>
                                <p className="size-s">En ocasiones las comercializadoras aplican descuentos sobre el consumo por promociones a ciertos clientes. Si lo aplican indíacalo en %, si no déjalo vacío.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input type="text" inputMode="decimal" id="descuentoAnalisis" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>
                  
                  </fieldset>

                  <button className="button primary full-width" onClick={() => verificarTarifa("Manual")}>Comprobemos si merece la pena...</button>

                </fieldset>

              </details>

            </div>

          </div>

          <div id="tablaResultadosAnalisis" className="vertical gap-04">

            
            <div className="bubble vertical text-center gap-06">

              <div className="vertical gap-02">
                <div id="textoResumenTipoResultado" className="headline-03 title"></div>
                <div id="textoResumenResultado" className="size-m"></div>              
              </div>

              <div id="divImportesResultados" className="horizontal gap-04">
                <div className="vertical fill center gap-01">
                  <span id="spanAlAño" className="title headline-02"></span>
                  <span className="size-m">al año</span>
                </div>
                <div className="vertical fill center gap-01">
                  <span id="spanAlMes" className="title headline-02"></span>
                  <span className="size-m">al mes</span>
                </div>
              </div>

              <div id="divBloqueOferta" className="vertical gap-02">
                
                <a id="aLinkOferta" href="https://www.fevergy.com" target="_blank" rel="noopener noreferrer" className="button primary full-width"> </a>

                <div id="mensajeComentarioContrataSolarSinPaneles" className="message warning hidden">
                  <p className="size-s">No nos hemos equivocado, puedes contratar tarifas solares sin tener paneles.</p>
                </div>

                <p id="labelTextoBonificacion" className=" hidden"></p>

              </div>

              <div id="divCompartenosTuTarifa" className="vertical gap-02 hidden">
                ¿Nos dices con qué compañía estás para que otros usuarios puedan ahorrar igual que tú?

                <fieldset className="horizontal gap-02">                  
                  <input id="nombreCompañiaMejorTarifa" type="text" className="" placeholder="Nombre de tu compañia"/>
                  <button className="button primary" onClick={() => enviarEmailTarifaMejor()}>Enviar</button>
                </fieldset>
              </div>

              <div id="mensajeRecordatorioReconfiguracion" className="message info">
                <p className="size-s">Si contratas una nueva tarifa, recuerda actualizarlas en <span className="link inline-link">Configuración</span> para que los cálculos sean correctos.</p>
              </div>

            </div>

            <details id="acordeonCalculosResultados" className="accordion">

              <summary className="title">
                <div className="vertical">
                  <span className="size-l">¿Cómo lo he calculado?</span>
                  <p id="textoIntroCalculos"></p>
                </div>
              </summary>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>BALANCE TOTAL</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Balance total</p>
                                <p className="size-s">Gastos / ganancias totales de cada tarifa con impuestos incluidos.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value size-m adhoc-width">Actual</td>
                      <td className="table-cell value size-m adhoc-width">Oferta</td>                      
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span id="literalTotales">Total facturas</span>
                      </td>
                      <td id="valorBalanceFinalActual" className="table-cell value size-l text"></td>
                      <td id="valorBalanceFinalOferta" className="table-cell value size-l text"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>POTENCIA</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Gastos de potencia</p>
                                <p className="size-s">Es lo que pagas por la potencia que tienes contratada, es un gasto fijo, te lo cobrarán aunque quites los plomos.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value size-m adhoc-width">Actual</td>
                      <td className="table-cell value size-m adhoc-width">Oferta</td>
                    </tr>
                    
                    <tr className="table-row vertical-start" id="trPotenciaP1">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P1: <span id="potenciaContratadaP1" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP1Actual"></span>
                          <span id="tarifaPotenciaP1Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP1Oferta"></span>
                          <span id="tarifaPotenciaP1Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>
                    
                    <tr className="table-row vertical-start" id="trPotenciaP2">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P2: <span id="potenciaContratadaP2" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP2Actual"></span>
                          <span id="tarifaPotenciaP2Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP2Oferta"></span>
                          <span id="tarifaPotenciaP2Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trPotenciaP3">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P3: <span id="potenciaContratadaP3" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP3Actual"></span>
                          <span id="tarifaPotenciaP3Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP3Oferta"></span>
                          <span id="tarifaPotenciaP3Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trPotenciaP4">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P4: <span id="potenciaContratadaP4" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP4Actual"></span>
                          <span id="tarifaPotenciaP4Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP4Oferta"></span>
                          <span id="tarifaPotenciaP4Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trPotenciaP5">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P5: <span id="potenciaContratadaP5" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP5Actual"></span>
                          <span id="tarifaPotenciaP5Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP5Oferta"></span>
                          <span id="tarifaPotenciaP5Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trPotenciaP6">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P6: <span id="potenciaContratadaP6" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kW/Día</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP6Actual"></span>
                          <span id="tarifaPotenciaP6Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorPotenciaContratadaP6Oferta"></span>
                          <span id="tarifaPotenciaP6Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>ENERGÍA</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Gastos de energía</p>
                                <p className="size-s">Estos son los gastos de tu consumo que dependen principalmente de tu instalación y el uso que le das.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value adhoc-width">Actual</td>
                      <td className="table-cell value adhoc-width">Oferta</td>
                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP1">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P1: <span id="consumoEnergiaP1" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>

                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP1Actual"></span>
                          <span id="tarifaEnergiaP1Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP1Oferta"></span>
                          <span id="tarifaEnergiaP1Oferta" className="size-s clarification"></span>
                        </div>
                      </td>

                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP2">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P2: <span id="consumoEnergiaP2" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP2Actual"></span>
                          <span id="tarifaEnergiaP2Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP2Oferta"></span>
                          <span id="tarifaEnergiaP2Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP3">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P3: <span id="consumoEnergiaP3" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP3Actual"></span>
                          <span id="tarifaEnergiaP3Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP3Oferta"></span>
                          <span id="tarifaEnergiaP3Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP4">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P4: <span id="consumoEnergiaP4" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP4Actual"></span>
                          <span id="tarifaEnergiaP4Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP4Oferta"></span>
                          <span id="tarifaEnergiaP4Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP5">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P5: <span id="consumoEnergiaP5" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP5Actual"></span>
                          <span id="tarifaEnergiaP5Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP5Oferta"></span>
                          <span id="tarifaEnergiaP5Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trEnergiaP6">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>P6: <span id="consumoEnergiaP6" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP6Actual"></span>
                          <span id="tarifaEnergiaP6Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorEnergiaP6Oferta"></span>
                          <span id="tarifaEnergiaP6Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>BONIFICACIONES</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Bonificaciones</p>
                                <p className="size-s">Son compensaciones económicas, ya sea por descuentos que te haga tu comercializadora, promociones de referidos o por el excedente solar que vuelvas y vendes a la red.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value adhoc-width">Actual</td>
                      <td className="table-cell value adhoc-width">Oferta</td>
                    </tr>
                    <tr className="table-row vertical-start" id="trExcedente" >
                      <td className="table-cell horizontal gap-02">      
                        <div className="vertical gap-01">
                          <span>Excedente: <span id="valorExcedente" className="size-s clarification"></span></span>
                          <span className="size-s clarification">Tarifa €/kWh</span>
                        </div>
                      </td>
                      <td className="table-cell value">
                        <div className="vertical gap-01">
                          <span id="valorExcedenteActual"></span>
                          <span id="tarifaExcedenteActual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value">
                        <div className="vertical gap-01">
                          <span id="valorExcedenteOferta"></span>
                          <span id="tarifaExcedenteOferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Descuentos</span>
                      </td>
                      <td id="valorDescuentoActual" className="table-cell value"></td>
                      <td id="valorDescuentoOferta" className="table-cell value"></td>
                    </tr>
                  </tbody>
                </table>
              </div>                    
                    
              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>OTROS GASTOS</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Otros gastos</p>
                                <p className="size-s">Son cargos adicionales que realiza tu comercializadora en concepto de servicios ofrecidos, como el alquiler de equipos, monedero solar, etc...</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value adhoc-width">Actual</td>
                      <td className="table-cell value adhoc-width">Oferta</td>
                    </tr>
                    <tr className="table-row vertical-start" id="trGastosFijosMonederoSolar">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Monedero solar / Baterías virtuales</span>
                      </td>
                      <td id="valorMonederoSolarActual" className="table-cell value"></td>
                      <td id="valorMonederoSolarOferta" className="table-cell value"></td>
                    </tr>
                    <tr className="table-row vertical-start" id="trGastosFijosAlquilerEquipos">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Servicios y complementos</span>
                      </td>
                      <td id="valorEquiposMedicionActual" className="table-cell value"></td>
                      <td id="valorEquiposMedicionOferta" className="table-cell value"></td>
                    </tr>
                    <tr className="table-row vertical-start" id="trGastosFijosAlquilerEquipos">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Comisión mensual compañía</span>
                      </td>
                      <td id="valorComisionFijaCompañiaActual" className="table-cell value"></td>
                      <td id="valorComisionFijaCompañiaOferta" className="table-cell value"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong style={{color: "orange"}}>IMPUESTOS</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Impuestos</p>
                                <p className="size-s">Hay otras cosas que te cobrarán como el impuesto de la electricidad, IVA, etc...</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value adhoc-width">Actual</td>
                      <td className="table-cell value adhoc-width">Oferta</td>
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Bono social</span>
                      </td>
                      <td id="valorBonoSocialActual" className="table-cell value"></td>
                      <td id="valorBonoSocialOferta" className="table-cell value"></td>
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Impuesto electricidad</span>
                      </td>
                      <td id="valorImpuestoElectricidadActual" className="table-cell value text"></td>
                      <td id="valorImpuestoElectricidadOferta" className="table-cell value text"></td>
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span id="literalIVAHoy">IVA</span>
                      </td>
                      <td id="importeIVAActual" className="table-cell value text"></td>
                      <td id="importeIVAOferta" className="table-cell value text"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </details>

          </div>

          <div id="analisis12Facturas" className="vertical hidden">

              <div className="bubble vertical gap-06">

                <div className="vertical gap-02">
                  <div className="headline-03 title">Servicio 12 facturas</div>
                  <p>Envíanos las últimas 12 facturas de cualquier instalación y <strong>te hacemos gratis un análisis personalizado</strong>. Te diremos si estás bien de potencia contratada y te buscaremos la tarifa de España con la que más ahorrarías.</p>              
                  <p>Si todavía no llevas un año usando Helias te recomendamos enviar las de esta instalacion. Aunque pueden ser de otra, como tu finca, la casa de tus padres, etc... </p>
                  <p>Este servicio tiene un <strong>límite de uso de una vez al año por cada instalación que tengas registrada en Helias</strong>. Podrías enviar más, pero tendría un coste del 7,5% del ahorro que te encontremos.</p>              
                </div>

                <div className="vertical gap-02">

                  <div id="mensaje12FacturasVersionPrueba" className="message warning">
                    <p className="size-s">Este <strong>servicio únicamente es gratuito para suscripciones que no estén en periodo de prueba</strong>. Si nos envías el informe durante dicho periodo conllevaría coste.</p>
                  </div>
                  
                  <a id="aLink12FacturasEmail" href="mailto:12facturas@fevergy.com" target="_blank" rel="noopener noreferrer" className="button primary full-width text-left">
                    <span className="material-icon">email</span>
                    <span>12facturas@fevergy.com</span>
                  </a>

                </div>

              </div>   

          </div>

      </>
  )
}

export default FeesAnalyzer